import React from 'react'
import Breadcrumbs from './Breadcrumbs'
import { Plus } from '@phosphor-icons/react'

const ProjectsHeader = ({
  projects_path,
  new_project_path,
  dashboard_path,
}) => {
  return (
    <div className="flex items-center justify-between pb-2">
      <Breadcrumbs
        list={[
          { label: 'Home', url: dashboard_path },
          { label: 'Projects', url: projects_path },
        ]}
      />
      <a href={new_project_path} className="btn btn-outline btn-ghost btn-secondary btn-xs">
        <span className="text-xs">New Project</span>
        <Plus weight="fill" color="black" size={20}/>
      </a>
    </div>
  )
}

export default ProjectsHeader